import { render, staticRenderFns } from "./LogManager.vue?vue&type=template&id=6b22e310&"
import script from "./LogManager.vue?vue&type=script&lang=js&"
export * from "./LogManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports